var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Controller, get, useFormContext, } from 'react-hook-form';
import { ReactChakraSelect as Select } from '@springcare/sh-component-library';
import { enumLabelsAsOptions } from 'shared/utils';
import { Box, chakraStyles, useFieldContext, Text } from 'shared/components';
import { noneEntered } from 'constants/strings';
import { SingleLineReadOnly } from './SingleLineReadOnly';
import { ErrorMessage } from '@hookform/error-message';
/* This is mostly copypasta from FormMultiSelect, but only allows a _single_ selection */
export var FormFilterSelect = function (_a) {
    var name = _a.name, placeholder = _a.placeholder, labelMap = _a.labelMap, clearable = _a.clearable, rules = _a.rules, errors = _a.errors, displayErrors = _a.displayErrors, dataTestId = _a.dataTestId;
    var _b = useFormContext(), control = _b.control, getValues = _b.getValues;
    var fieldContext = useFieldContext();
    var isClearable = clearable !== undefined ? clearable : true;
    var errorMessages = get(errors, name);
    var hasError = !!(errors && errorMessages);
    if (fieldContext && fieldContext.readOnly) {
        return (_jsx(SingleLineReadOnly, { text: getValues(name) || noneEntered, noneEntered: !getValues(name) }));
    }
    return (_jsx(Controller, { control: control, name: name, rules: rules, render: function (_a) {
            var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref, error = _a.fieldState.error;
            return (_jsxs(Box, __assign({ "data-testid": name }, { children: [_jsx(Select, __assign({ "data-testid": dataTestId, name: name, ref: ref, value: {
                            label: labelMap[value],
                            value: value,
                        }, onChange: function (option) {
                            onChange((option === null || option === void 0 ? void 0 : option.value) || '');
                        }, options: enumLabelsAsOptions(labelMap), onBlur: onBlur, placeholder: placeholder, hideSelectedOptions: false, selectedOptionStyle: "check", isClearable: isClearable && value, chakraStyles: chakraStyles }, (displayErrors && hasError && { isInvalid: true }))), displayErrors && hasError && (_jsx(ErrorMessage, { errors: errors, 
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        name: name, render: function (_a) {
                            var message = _a.message;
                            return (_jsx(Box, { children: _jsx(Text, __assign({ "data-testid": "errors-".concat(name), color: "red.500", fontWeight: "semibold" }, { children: message })) }));
                        } }))] })));
        } }));
};
